// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filtersContainer {\n  position: absolute;\n  top: 0px;\n  right: 20px;\n}\n.filtersContainer .dropdown-menu {\n  max-height: 355px;\n  overflow: auto;\n  top: 40px !important;\n}\n.filterElement {\n  display: inline-block;\n}\n\n\n", ""]);
// Exports
module.exports = exports;
